module.exports = __webpack_public_path__ + "static/media/learnTabUnselected.44d95cae.png";